export type SortCriterionKey =
  | 'favorites'
  | 'lastPurchase'
  | 'category'
  | 'description'
  | 'availability'
  | 'concorded';

export interface SortCriterion {
  key: SortCriterionKey;
  enabled: boolean;
}

export interface SortProfile {
  id: string;
  name: string;
  criteria: SortCriterion[];
  customerIds: string[];
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PreferencesState {
  profiles: SortProfile[];
}

export const CRITERION_LABELS: Record<SortCriterionKey, string> = {
  favorites: 'Preferiti',
  lastPurchase: 'Ultimo acquisto (desc)',
  category: 'Categoria',
  description: 'Descrizione A→Z',
  availability: 'Disponibilità',
  concorded: 'Concordati',
};

export const ALL_SORT_CRITERION_KEYS: SortCriterionKey[] = [
  'favorites',
  'lastPurchase',
  'category',
  'description',
  'availability',
  'concorded',
];

export const DEFAULT_SORT_PROFILE: SortProfile = {
  id: 'default',
  name: 'Standard',
  isDefault: true,
  customerIds: [],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  criteria: [
    { key: 'favorites', enabled: true },
    { key: 'lastPurchase', enabled: true },
    { key: 'category', enabled: true },
    { key: 'description', enabled: true },
    { key: 'availability', enabled: false },
    { key: 'concorded', enabled: false },
  ],
};
